import React from 'react'
import PropTypes from 'prop-types'
import Button from 'components/shared/Button/Button'
import Icon from 'components/shared/Icon/Icon'
import { useGTMDispatch } from '@elgorditosalsero/react-gtm-hook'

import { translate } from 'react-i18next'

import './CodeClubCard.scss'

export const CodeClubCard = ({ t, gtm = {} }) => {
  const sendDataToGTM = useGTMDispatch()
  const handleClick = () =>
    sendDataToGTM({ ...gtm, label: 'CTA: Find Code Club' })

  const paragraphs = t('homepage.clubs.cards.codeclub.description', {
    returnObjects: true,
  })

  return (
    <div className="c-code-club-card">
      <div className="c-code-club-card__wrapper">
        <div className="c-code-club-card__text">
          <h2 className="c-code-club-card__title">
            {t('homepage.clubs.cards.codeclub.title')}
          </h2>
          <div className="c-code-club-card__description">
            {Array.isArray(paragraphs) &&
              paragraphs.map((paragraph, idx) => (
                <p key={`item-${idx}`}>{paragraph}</p>
              ))}
          </div>
          <Button
            className="c-code-club-card__button"
            textAlways
            icon={<Icon type="external-link" />}
            iconAlignment="right"
            type="primary"
            text={t('homepage.clubs.cards.codeclub.button')}
            href="https://codeclub.org"
            onClick={handleClick}
          ></Button>
        </div>
        <div className="c-code-club-card__image">
          <img
            src="/images/codeclub-image.png"
            alt={t('homepage.clubs.cards.codeclub.image_alt')}
          />
        </div>
      </div>
    </div>
  )
}

CodeClubCard.propTypes = {
  t: PropTypes.func.isRequired,
  gtm: PropTypes.object,
}

export default translate('translations')(CodeClubCard)
